import { QueryClient } from '@tanstack/react-query'
import LogTool from '../logger/logTools'

const log = new LogTool({ context: 'QueryClient', enable: true, logLevel: 'warn' })

/**
 * Creates and configures the React Query QueryClient with sensible defaults
 * for the application.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 5 minutes
      staleTime: 5 * 60 * 1000,
      
      // Cache data for 10 minutes
      gcTime: 10 * 60 * 1000,
      
      // Retry failed requests up to 2 times
      retry: (failureCount, error: any) => {
        // Don't retry on 4xx errors (client errors)
        if (error?.status >= 400 && error?.status < 500) {
          return false
        }
        // Retry up to 2 times for other errors
        return failureCount < 2
      },
      
      // Retry delay with exponential backoff
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      
      // Don't refetch on window focus in development to avoid unnecessary requests
      refetchOnWindowFocus: process.env.NODE_ENV === 'production',
      
      // Refetch on reconnect
      refetchOnReconnect: true,
      
      // Don't refetch on mount if data is still fresh
      refetchOnMount: true,
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
      
      // Global error handler for mutations
      onError: (error: any) => {
        log.error('Mutation error:', error)
      },
    },
  },
})

